module.exports = {
  SEND_MOBILE_APP_LINK_SMS: 'OTT/user/SEND_PHONE_NUMBER',
  SEND_MOBILE_APP_LINK_SMS_SUCCESS: 'OTT/user/SEND_PHONE_SUCCESS',
  SEND_MOBILE_APP_LINK_SMS_FAIL: 'OTT/user/SEND_PHONE_FAIL',
};
